var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 27,
    viewBox: "0 0 36 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7875 21.8367C25.6161 22.0213 25.521 22.269 25.5228 22.5263C25.5247 22.7836 25.6232 23.0299 25.7973 23.2118C25.9713 23.3938 26.2068 23.4968 26.4529 23.4987C26.699 23.5006 26.936 23.4012 27.1125 23.222C32.2203 18.0918 32.2203 8.90602 27.1124 3.77599C26.9357 3.59704 26.6989 3.49788 26.4529 3.49991C26.207 3.50194 25.9717 3.60499 25.7978 3.78682C25.6239 3.96866 25.5253 4.2147 25.5234 4.47183C25.5215 4.72897 25.6164 4.97658 25.7875 5.16122C27.8912 7.37885 29.0716 10.3757 29.0716 13.499C29.0716 16.6223 27.8912 19.6191 25.7875 21.8367Z",
    fill: "url(#paint0_linear_418_8)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76701e-05 13.4991C-0.00471544 15.9449 0.454646 18.3674 1.35153 20.6263C2.2484 22.8853 3.56498 24.9358 5.22504 26.6591C5.40162 26.8384 5.63858 26.9378 5.88472 26.9359C6.13086 26.9341 6.36641 26.831 6.54045 26.649C6.7145 26.467 6.81307 26.2208 6.81486 25.9634C6.81664 25.7061 6.7215 25.4584 6.55 25.2738C0.358874 19.0637 0.359069 7.93423 6.55021 1.72427C6.72161 1.53962 6.81664 1.29188 6.81479 1.03459C6.81293 0.777289 6.71434 0.531082 6.5403 0.349154C6.36626 0.167226 6.13075 0.0641824 5.88464 0.0622826C5.63854 0.0603828 5.4016 0.159779 5.22501 0.339001C3.56495 2.06234 2.24838 4.11284 1.3515 6.37178C0.454627 8.63072 -0.00472641 11.0532 3.76701e-05 13.4991Z",
    fill: "url(#paint1_linear_418_8)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65632 13.4989C4.65255 15.3056 4.99142 17.0952 5.65332 18.7641C6.31523 20.433 7.28705 21.9482 8.51257 23.2219C8.68916 23.4012 8.92609 23.5005 9.17219 23.4986C9.41829 23.4967 9.65378 23.3937 9.8278 23.2117C10.0018 23.0298 10.1004 22.7836 10.1022 22.5263C10.104 22.269 10.009 22.0213 9.83753 21.8367C7.73386 19.619 6.55349 16.6222 6.55352 13.4989C6.55355 10.3756 7.73397 7.37879 9.83769 5.16119C10.009 4.97652 10.1039 4.72884 10.102 4.47162C10.1001 4.2144 10.0015 3.96828 9.82751 3.78641C9.65353 3.60453 9.4181 3.5015 9.17208 3.49954C8.92605 3.49758 8.68915 3.59687 8.51254 3.77596C7.28702 5.04973 6.31521 6.56489 5.65331 8.2338C4.9914 9.9027 4.65254 11.6922 4.65632 13.4989Z",
    fill: "url(#paint2_linear_418_8)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9626 13.499C13.9651 14.5657 14.3716 15.588 15.093 16.3422C15.8145 17.0965 16.7923 17.5214 17.8126 17.5241C22.9069 17.3291 22.9055 9.66808 17.8125 9.47388C16.7922 9.47657 15.8144 9.90151 15.093 10.6558C14.3716 11.4101 13.9651 12.4323 13.9626 13.499Z",
    fill: "url(#paint3_linear_418_8)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0751 25.2737C28.9041 25.4585 28.8095 25.706 28.8115 25.963C28.8135 26.22 28.9121 26.4659 29.0859 26.6477C29.2597 26.8294 29.4949 26.9325 29.7408 26.9346C29.9866 26.9367 30.2234 26.8377 30.4001 26.659C37.3203 19.7159 37.3203 7.28181 30.3999 0.338918C30.2233 0.159723 29.9864 0.0603556 29.7403 0.0622834C29.4942 0.0642112 29.2587 0.16728 29.0847 0.349221C28.9108 0.531162 28.8122 0.777367 28.8104 1.03464C28.8086 1.29192 28.9037 1.5396 29.0751 1.72419C35.2662 7.93444 35.2661 19.0637 29.0751 25.2737Z",
    fill: "url(#paint4_linear_418_8)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31255 13.499C9.30975 14.6666 9.52812 15.8232 9.95506 16.9021C10.382 17.981 11.0091 18.9608 11.8001 19.785C11.9773 19.9662 12.2156 20.067 12.4635 20.0655C12.7113 20.0641 12.9486 19.9605 13.1239 19.7773C13.2992 19.594 13.3982 19.3459 13.3996 19.0868C13.401 18.8277 13.3046 18.5785 13.1313 18.3932C11.894 17.0928 11.1995 15.3332 11.1995 13.499C11.1996 11.6648 11.8941 9.90522 13.1314 8.60484C13.3078 8.42024 13.4069 8.16995 13.4068 7.909C13.4067 7.64805 13.3076 7.3978 13.1311 7.21329C12.9546 7.02877 12.7152 6.9251 12.4656 6.92505C12.216 6.925 11.9766 7.02859 11.8001 7.21304C11.009 8.03726 10.382 9.01708 9.95505 10.096C9.52811 11.1749 9.30974 12.3314 9.31255 13.499Z",
    fill: "url(#paint5_linear_418_8)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4938 8.60469C23.1099 9.24661 23.5988 10.0094 23.9323 10.8492C24.2659 11.6891 24.4376 12.5895 24.4376 13.4989C24.4376 14.4082 24.2659 15.3087 23.9323 16.1485C23.5988 16.9884 23.1099 17.7511 22.4938 18.393C22.3222 18.5787 22.2272 18.8273 22.2292 19.0855C22.2313 19.3437 22.3304 19.5906 22.505 19.7732C22.6796 19.9558 22.9158 20.0593 23.1628 20.0615C23.4097 20.0636 23.6476 19.9643 23.8251 19.7848C25.4086 18.1116 26.2968 15.8527 26.2968 13.4988C26.2967 11.145 25.4085 8.88615 23.825 7.21289C23.6475 7.03334 23.4096 6.93393 23.1626 6.93607C22.9156 6.93821 22.6793 7.04174 22.5047 7.22434C22.33 7.40694 22.231 7.65398 22.229 7.91219C22.227 8.17041 22.3221 8.41911 22.4938 8.60469Z",
    fill: "url(#paint6_linear_418_8)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_418_8",
    x1: 28.2331,
    y1: 3.49988,
    x2: 28.2331,
    y2: 23.4987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A63C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_418_8",
    x1: 3.40744,
    y1: 0.0622559,
    x2: 3.40744,
    y2: 26.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A63C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_418_8",
    x1: 7.37926,
    y1: 3.49951,
    x2: 7.37926,
    y2: 23.4987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A63C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_418_8",
    x1: 17.7977,
    y1: 9.47388,
    x2: 17.7977,
    y2: 17.5241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A63C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_418_8",
    x1: 32.2003,
    y1: 0.0622559,
    x2: 32.2003,
    y2: 26.9346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A63C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_418_8",
    x1: 11.3597,
    y1: 6.92505,
    x2: 11.3597,
    y2: 20.0655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A63C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_418_8",
    x1: 24.2629,
    y1: 6.93604,
    x2: 24.2629,
    y2: 20.0615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A63C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2868"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.21e3cf3126e3e34ae2d30ed5470e93a5.svg";
export { ForwardRef as ReactComponent };